<template>
<div class="list">
    <div class="item-card"
         v-for="(item, index) in list"
         :key="item.id"
         @click.stop="onTapDetail(index)">
        <div class="image">
            <img class="bg-img" v-lazy="generateObj(item.image||item.image_url||item.cover_image_url)" />
        </div>
        <div class="info">
            <div class="up">
                <div class="name" :class="{'shop': category=='site_shop' }">
                    {{item.name}}
                </div>
                <div class="tag">
                    <div class="tagItem"
                        v-for="(tag, index) in item.labels"
                        :key="tag">
                        <span v-if="index < 3">{{tag}}</span>
                    </div>
                </div>
                <div class="date" v-if="category==='show_item'">{{item.time||''}}</div>
                <div class="score">
                    <Score v-if="item.rating"
                        :rating="item.rating" />
                    <div class="comment" v-if="item.reviews">{{item.reviews}}评论</div>
                </div>
            </div>
            <!--价格 评分-->
            <div class="bottom">
                <!--景点、演出、活动（有ticket——type）-->
                <div class="price-info"
                    v-if="category=='site'||category=='show_item'||category==='site_activity'">
                    <div class="has-price" v-if="item.ticket_type === 'supported'">
                        <div class="price-text" v-if="item.best_price!==null">
                            <span class="red">{{symbol}}</span>
                            <span class="digital">{{item.best_price/100}}</span>
                            <span class="gray">起</span>
                        </div>
                    </div>
                    <div class="has-price" v-else-if="item.ticket_type==='unsupported'">
                        <div class="price-text" v-if="item.low_price!==null">
                            <span class="red">{{symbol}}</span>
                            <span class="digital">{{item.low_price/100}}</span>
                            <span class="gray">起</span>
                        </div>
                    </div>
                    <div class="no-price" v-else>
                        免费
                    </div>
                </div>
                <!--酒店（直接显示最低价）-->
                <div class="price-info"
                    v-if="category=='hotel'">
                    <div class="has-price" v-if="item.best_price!==0">
                        <div class="price-text" v-if="item.best_price!==null">
                            <text class="red">{{symbol}}</text>
                            <!--酒店价格单位为元-->
                            <text class="digital">{{item.best_price}}</text>
                            <text class="gray">起</text>
                        </div>
                    </div>
                    <div class="no-price" v-else>
                        <!--免费-->
                    </div>
                </div>
                <!--美食-->
                <div class="price-info" v-if="category=='merchant'">
                    <div class="has-price" v-if="item.best_price&&item.best_price!=0">
                        <div class="price-text">
                            <text class="red">{{symbol}}</text>
                            <text class="digital">{{item.best_price/100}}</text>
                            <text class="gray">/人</text>
                        </div>
                    </div>
                    <div class="no-price" v-else-if="item.best_price===0">
                        免费
                    </div>
                    <div class="no-price null" v-else>no price</div>
                </div>
                <!--购物-->
                <div class="price-info" v-if="category=='site_shop'"></div>
                <!--优惠-->
                <div class="time-info" v-if="category=='poi_promotion'">
                    {{item.time||''}}
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Score from '../Score'

export default {
    data () {
        return {
            symbol: 'S$'//新加坡币
        }
    },
    props: {
        category: {
            type: String,
            default: ''
        },
        list: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    components: {
       Score 
    },
    methods: {
        generateObj (src) {
            return {
                src,
                error: '/image/default_img.jpg',
                loading: '/image/loading-img.jpg'
            }
        },
        onTapDetail (index) {
            this.$emit('detail', index)
        }
    }
}
</script>

<style lang="scss">
//列表模式
.list{
    .item-card {
        display: flex;
        width: 100%;
        color: #ffffff;
        padding: 12px;
        //margin-bottom: 12px;
        border-bottom: 6px solid #f7f7f7;
        &:last-child{
            border-bottom:none;
        }
        .image{
            position: relative;
            width: 100px;
            height: 100px;
            //border-radius: 16rpx;
            //will-change: transform;
            overflow: hidden;
            .bg-img{
                width: 100%;
                height: 100%;
                will-change: transform;
                background-color: #d8d8d8;
            }
            .trip-mask{
                position: absolute;
                z-index: 1;
                top: 0;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                //bottom: -4rpx;
                width: 100%;
                height: 100%;
                font-size: 14px;
                color: #ffffff;
                //opacity: 0.5;
                //padding-top: 10rpx;
                background-color: rgba(0,0,0,0.5);
            }
        }
        .info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            //width: 63%;
            width: calc(100% - 110px);
            height: 100px;
            margin-left: 10px;
            padding: 6px 0 4px 0;
            //width: 100%;
            .up{
                .name{
                    max-width: 205px;
                    font-size: 14px;
                    line-height: 1.2em;
                    font-weight: bold;
                    font-family: GothamBold;
                    color: #222125;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .tag{
                    display: flex;
                    align-items: center;
                    padding-top: 4px;
                    .tagItem{
                        display: flex;
                        align-items: center;
                        padding: 0 3px;
                        height: 14px;
                        border-radius: 2px;
                        font-size: 10px;
                        color: #ed9107;
                        margin-right: 5px;
                        border: solid 1px #ed9107;
                        //max-width: 120rpx;
                        //white-space: nowrap;
                        //overflow: hidden;
                        //text-overflow: ellipsis;
                    }
                }
                .date{
                    font-size: 10px;
                    color: #888888;
                    margin-top: 5px;
                    max-width:100%;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
                .score{
                    display: flex;
                    align-items: center;
                    margin-top: 6px;
                    //transform: translateY(4rpx);
                    .score-logo{
                        margin-right: 3px;
                    }
                    .comment{
                        font-size: 10px;
                        color: #666666;
                        margin-left: 11px;
                        // transform: translateY(1px);
                    }
                }
            }
            .bottom {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: space-between;
                //align-items: baseline;
                width: 100%;
                //height: 36rpx;
                //margin-top:13.6rpx;
                .price-info{
                    .has-price{
                        display: flex;
                        align-items: baseline;
                        .price-text{
                            color: #60c2ed;
                            line-height: 1;
                            .red{
                                display:inline-block;
                                font-size: 14px;
                                margin-right: 2px;
                                // transform: translateY(1rpx);
                            }
                            .digital{
                                display: inline-block;
                                font-size: 14px;
                                //font-weight:bold;
                                // transform: translateY(1rpx);
                            }
                            .gray{
                                font-size: 11px;
                                margin-left: 2px;
                            }
                        }
                    }
                    .no-price{
                        line-height: 1;
                        font-size: 14px;
                        color: #60c2ed;
                        padding-top: 4px;
                        text-align: left;
                        &.null{
                            color: #fff;
                        }
                        .price-text{
                            color: #60c2ed;
                            line-height: 1;
                            .red{
                                display:inline-block;
                                font-size: 14px;
                                margin-right: 2px;
                                // transform: translateY(1rpx);
                            }
                            .digital{
                                display: inline-block;
                                font-size: 14px;
                                //font-weight:bold;
                                // transform: translateY(1rpx);
                            }
                            .gray{
                                font-size: 11px;
                                margin-left: 2px;
                            }
                        }
                        //transform: translateY(2rpx);
                    }
                }
                .time-info{
                    max-width: 100%;
                    font-size: 12px;
                    font-weight: bold;
                    font-family: GothamBold;
                    color: #60c2ed;
                    //padding-top:8rpx;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                //添加景点至行程按钮
                .trip-btn{
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    .btn{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 52px;
                        height: 26px;
                        border-radius: 4px;
                        font-size: 14px;
                        //font-weight: bold;
                        &.add{
                            color: #ffffff;
                            background-color: #f8a909;
                        }
                        &.remove{
                            color: #888888;
                            border: solid 1px #888888;
                        }
                    }
                }
            }
        }
    }
}
</style>